<div class="student-form-page">
  <div class="container student-form-shell">
    @if (studentForm) {
      <section class="student-form-hero">
        <div class="student-form-hero-copy">
          <div class="student-form-badges">
            <span class="student-form-chip student-form-chip--state">{{ canSubmit ? 'Mode édition' : 'Mode consultation' }}</span>
            <button type="button" class="student-form-chip student-form-chip--action" (click)="onBackToStudentDetails()">
              <i class="fa fa-arrow-left"></i> Retour au dossier
            </button>
          </div>
          <h1>{{ studentForm.value.lastname }} {{ studentForm.value.firstname }}</h1>
          <p class="student-form-subtitle">
            Coordonnées, formule et informations administratives du dossier.
          </p>
        </div>
        <div class="student-form-hero-actions">
          @if (!canSubmit && !readOnlyService.isReadOnly()) {
            <button type="button" class="btn btn-outline-primary" (click)="onEditActive()">
              <i class="fa fa-pencil-square-o"></i> Modifier
            </button>
          }
          @if (canSubmit) {
            <button type="button" class="btn btn-outline-secondary" (click)="onCancelEdit()">
              <i class="fa fa-times"></i> Annuler
            </button>
          }
          @if (canSubmit) {
            <button type="submit" class="btn btn-success" form="student-edit-form" (click)="isSubmited(f.form)">
              <i class="fa fa-check"></i> Enregistrer
            </button>
          }
          <button type="button" class="btn btn-primary" (click)="uploadIdentificationFile(studentForm.value.id)">
            <i class="fa fa-file-text-o"></i> Fiche d'identification
          </button>
          <button type="button" class="btn btn-primary" (click)="uploadContract(studentForm.value.id)">
            <i class="fa fa-download"></i> Contrat PDF
          </button>
        </div>
      </section>
    }

    @if (messageError != null && messageError.length > 0) {
      <div class="alert alert-danger student-form-alert student-form-alert--error" role="alert"
        >
        <p class="alert-heading mb-1">Enregistrement impossible</p>
        <p class="mb-0">{{ messageError }}</p>
      </div>
    }

    @if (isSaved) {
      <div class="alert alert-success student-form-alert" role="alert">
        <p class="alert-heading mb-0">La mise à jour est réussie.</p>
      </div>
    }

    <form id="student-edit-form" class="student-edit-form" [formGroup]="studentForm" #f="ngForm" name="editEventForm"
      (ngSubmit)="onEditStudent()" novalidate>
      <section class="student-form-card">
        <div class="student-form-card-head">
          <div>
            <h2>Profil</h2>
          </div>
        </div>

        <div class="form-row">
          <div class="col-md-4 mb-3">
            <label>Civilité</label>
            <div class="student-form-radio-group">
              <label class="student-form-radio">
                <input class="input-form" type="radio" name="sexe" formControlName="sexe" value="F">
                <span>Madame</span>
              </label>
              <label class="student-form-radio">
                <input class="input-form" type="radio" name="sexe" formControlName="sexe" value="M">
                <span>Monsieur</span>
              </label>
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <label for="formulaId">Formule</label>
            <select id="formulaId" class="form-control input-form" formControlName="formulaId">
              <option [ngValue]="null" disabled>Choisir une formule</option>
              @for (f of formulas; track f) {
                <option [ngValue]="f.id">
                  {{ f.name }} - {{ f.price }} €
                  @if (f.disabled) {
                    (désactivée)
                  }
                  @if (!f.disabled && f.id === studentFormula?.id) {
                    ✓ (déjà associée)
                  }
                </option>
              }
            </select>
            @if (canSubmit && (f.form.controls.formulaId.status == 'INVALID')) {
              <p class="p-alert" role="alert">
                Merci de choisir une formule !
              </p>
            }
          </div>

          <div class="col-md-4 mb-3">
            <label for="neph">NEPH</label>
            <input type="text" class="form-control input-form" id="neph" formControlName="neph" placeholder="Numéro NEPH">
          </div>
        </div>

        <div class="form-row">
          <div class="col-md-4 mb-3">
            <label for="name">Nom</label>
            <input type="text" class="form-control input-form" id="name" formControlName="lastname" placeholder="Nom" required>
            @if (canSubmit && (f.form.controls.lastname.status == 'INVALID')) {
              <p class="p-alert" role="alert">
                Merci de définir le prénom !
              </p>
            }
          </div>

          <div class="col-md-4 mb-3">
            <label for="firstname">Prénom</label>
            <input type="text" class="form-control input-form" id="firstname" formControlName="firstname" placeholder="Prénom" required>
            @if (canSubmit && (f.form.controls.firstname.status == 'INVALID')) {
              <p class="p-alert" role="alert">
                Merci de définir le nom !
              </p>
            }
          </div>

          <div class="col-md-4 mb-3">
            <label for="birthPlace">Lieu de naissance</label>
            <input type="text" class="form-control input-form" id="birthPlace" formControlName="birthPlace" placeholder="Lieu de naissance" required>
            @if (canSubmit && (f.form.controls.birthPlace.status == 'INVALID')) {
              <p class="p-alert" role="alert">
                Merci de définir le lieu de naissance !
              </p>
            }
          </div>
        </div>

        <div class="form-row">
          <div class="col-md-4 mb-3">
            <label for="birthDate">Date de naissance</label>
            <input type="date" class="form-control input-form" id="birthDate" formControlName="birthDate"
              [class.is-invalid]="isControlInvalid('birthDate')" required>
            @if (isControlInvalid('birthDate')) {
              <p class="p-alert" role="alert">
                Merci de définir la date de naissance !
              </p>
            }
          </div>

          <div class="col-md-4 mb-3">
            <label for="hasCode">Code obtenu</label>
            <select id="hasCode" class="form-control input-form" formControlName="hasCode">
              <option [ngValue]="false">Non</option>
              <option [ngValue]="true">Oui</option>
            </select>
            @if (canSubmit && (f.form.controls.hasCode.status == 'INVALID')) {
              <p class="p-alert" role="alert">
                Merci de définir si l'élève a eu le code !
              </p>
            }
          </div>

          <div class="col-md-4 mb-3">
            @if (!isNewStudent) {
              <label for="registrationDate">Date d'inscription</label>
            }
            @if (isNewStudent) {
              <label for="registrationDate2">Date d'inscription</label>
            }
            @if (!isNewStudent) {
              <input type="date" class="form-control" id="registrationDate"
                [value]="studentForm.value.evaluationDate || studentForm.value.registrationDate"
                placeholder="Date d'inscription" readonly>
            }
            @if (isNewStudent) {
              <input type="date" class="form-control input-form" id="registrationDate2"
                [class.is-invalid]="isControlInvalid('registrationDate')"
                formControlName="registrationDate" placeholder="Date d'inscription" required>
            }
            @if (isNewStudent && isControlInvalid('registrationDate')) {
              <p class="p-alert" role="alert">
                Merci de définir la date !
              </p>
            }
          </div>
        </div>
      </section>

      <section class="student-form-card">
        <div class="student-form-card-head">
          <div>
            <h2>Coordonnées</h2>
          </div>
        </div>

        <div class="form-row">
          <div class="col-md-6 mb-3">
            <label for="email">Email</label>
            <input type="email" class="form-control input-form" id="email" formControlName="email" placeholder="Email" required>
            @if (canSubmit && (f.form.controls.email.status === 'INVALID')) {
              <p class="p-alert" role="alert">
                Email invalide ou déjà utilisé !
              </p>
            }
          </div>

          <div class="col-md-6 mb-3">
            <label for="phoneNumber">Téléphone</label>
            <input type="text" class="form-control input-form" id="phoneNumber" formControlName="phoneNumber" placeholder="Téléphone" required>
            @if (canSubmit && (f.form.controls.phoneNumber.status == 'INVALID')) {
              <p class="p-alert" role="alert">
                Merci de définir un numéro de téléphone !
              </p>
            }
          </div>
        </div>

        <div class="form-row">
          <div class="col-md-6 mb-3">
            <label for="address">Adresse</label>
            <input type="text" class="form-control input-form" id="address" formControlName="address" placeholder="Adresse" required>
            @if (canSubmit && (f.form.controls.address.status == 'INVALID')) {
              <p class="p-alert" role="alert">
                Merci de définir l'adresse
              </p>
            }
          </div>

          <div class="col-md-3 mb-3">
            <label for="postalCode">Code postal</label>
            <input type="text" class="form-control input-form" id="postalCode" formControlName="postalCode" placeholder="Code postal" required>
            @if (canSubmit && (f.form.controls.postalCode.status == 'INVALID')) {
              <p class="p-alert" role="alert">
                Merci de définir le code postal !
              </p>
            }
          </div>

          <div class="col-md-3 mb-3">
            <label for="city">Ville</label>
            <input type="text" class="form-control input-form" id="city" formControlName="city" placeholder="Ville" required>
            @if (canSubmit && (f.form.controls.city.status == 'INVALID')) {
              <p class="p-alert" role="alert">
                Merci de définir la ville !
              </p>
            }
          </div>
        </div>
      </section>

      <section class="student-form-card">
        <div class="student-form-card-head">
          <div>
            <h2>Planning</h2>
          </div>
        </div>

        <div class="form-row">
          <div class="col-md-3 mb-3">
            <label for="evalDate">Date de l'évaluation</label>
            <input type="date" class="form-control input-form" id="evalDate" formControlName="evaluationDate"
              [class.is-invalid]="isControlInvalid('evaluationDate')" required>
            @if (isControlInvalid('evaluationDate')) {
              <p class="p-alert" role="alert">
                Merci de définir la date d'évaluation !
              </p>
            }
          </div>

          <div class="col-md-3 mb-3">
            <label for="evaluationHours">Heures évaluées</label>
            <input type="number" class="form-control input-form" id="evaluationHours" formControlName="evaluationHours" placeholder="Nombre d'heures évaluées" required>
            @if (canSubmit && (f.form.controls.evaluationHours.status == 'INVALID')) {
              <p class="p-alert" role="alert">
                Merci de définir le nombre d'heures évaluées !
              </p>
            }
          </div>

          <div class="col-md-3 mb-3">
            <label for="agreedNumberHours">Heures convenues</label>
            <input type="number" class="form-control input-form" id="agreedNumberHours" formControlName="agreedNumberHours" placeholder="Nombre d'heures convenues" required>
            @if (canSubmit && (f.form.controls.agreedNumberHours.status == 'INVALID')) {
              <p class="p-alert" role="alert">
                Merci de définir le nombre d'heures convenues !
              </p>
            }
          </div>

          <div class="col-md-3 mb-3">
            <label for="contractDate">Date du contrat</label>
            <input type="date" class="form-control input-form" id="contractDate" formControlName="contractDate" placeholder="Date du contrat">
          </div>
        </div>

        <div class="form-row">
          <div class="col-md-3 mb-3">
            <label for="settlementDate">Règlement intérieur</label>
            <input type="date" class="form-control input-form" id="settlementDate" formControlName="settlementDate" placeholder="Date du règlement intérieur">
          </div>
        </div>
      </section>

      @if (canSubmit) {
        <div class="student-form-footer">
          <button class="btn btn-primary student-form-submit" type="submit" (click)="isSubmited(f.form)">
            Enregistrer
          </button>
        </div>
      }
    </form>
  </div>
</div>
